import { createAction, props } from '@ngrx/store';

export const reportViewerSetScrolled = createAction(
  '[Report Viewer Component] Set Scrolled',
  props<{ scrolled: boolean }>()
);
export const reportViewerVirtualScrolledRendered = createAction(
  '[Report Viewer Embed Component] Virtual Scrolled Rendered'
);
export const reportViewerVirtualRendered = createAction('[Report Viewer Component] Virtual Rendered');
export const reportViewerSetInViewport = createAction(
  '[Report Viewer Component] Set InViewport',
  props<{ intersections: Record<string, boolean> }>()
);
export const reportViewerSetVirtualEnabled = createAction(
  '[Report Viewer Component] Set Enabled',
  props<{ enabled: boolean }>()
);

/**
 * This takes in a boolean in case we might need to set it to false
 * in the future, and it isn't much extra effort.
 */
export const reportViewerSetHasRendered = createAction(
  '[Report Viewer Component] Set HasRendered',
  props<{ token: string; rendered: boolean }>()
);

export const reportBuilderSetVirtualEnabled = createAction(
  '[Report Builder Component] Set Enabled',
  props<{ enabled: boolean }>()
);
export const reportBuilderSetInViewport = createAction(
  '[Report Builder Component] Set InViewport',
  props<{ intersections: Record<string, boolean> }>()
);
export const reportBuilderSetHasRendered = createAction(
  '[Report Builder Component] Set HasRendered',
  props<{ token: string; rendered: boolean }>()
);
export const reportBuilderSetScrolled = createAction(
  '[Report Builder Component] Set Scrolled',
  props<{ scrolled: boolean }>()
);
export const reportBuilderVirtualScrolledRendered = createAction(
  '[Report Builder Embed Component] Virtual Scrolled Rendered'
);
export const reportBuilderVirtualRendered = createAction('[Report Builder Component] Virtual Rendered');
